module.exports = __webpack_public_path__ + "static/img/player_head_37.03bb515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_37.jpg
// module id = c2W9
// module chunks = 1